const alerts = {
    createAffliation: "createAffliation",
    createTestTaker: "createTestTaker",
    createTestTakers: "createTestTakers",
    backTo: "backTo",
    createGrade: "createGrade",
    createClass: "createClass",
    createClass2: "createClass2",
    createShortClass: "createShortClass",
    newChild: "newChild",
    contactUs: "contactUs",
    schoolSetup: "schoolSetup",
    micErrors: "micErrors",
    downloadStudentFile: "downloadStudentFile",
    addSchoolClass: "addSchoolClass",
    addLearningGroup: "addLearningGroup",
    performAssessment: "performAssessment",
    recordInstructions: "recordInstructions",
    preview: "preview",
    noBalance: "noBalance",
    newletterActions: "newletterActions",
    exitScreen: "exitScreen",
    performAssessmentAgain: "performAssessmentAgain",
    finishPerformAseessment: "finishPerformAseessment",
    exitEditAffiliation: "exitEditAffiliation",
    initializeAssessment: "initializeAssessment",
    createCoupon: "createCoupon",
    versionMessage: "versionMessage",
    selectStatusType: "selectStatusType",
    stuckReason: "stuckReason",
    uploadAudio: "uploadAudio",
    removeAssessment: "removeAssessment",
    deleteAssessments: "deleteAssessments",
    removeTicket: "removeTicket",
    removeTicketMessage: "removeTicketMessage",
    normalatorConfirmation: "normalatorConfirmation",
    exitNormalator: "exitNormalator"
}

export default alerts